export const MODES_TITLES = {
    developmentIndicators: 'developmentIndicators',
    comparisonOfPeriods: 'comparisonOfPeriods',
    approximation: 'approximation',
    consolidatedProduction: 'consolidatedProduction',
    wellList: 'wellList',
};

// TODO: need be doing much more matching with backend.
export const OBJECT_TYPE = {
    develop: 'developId',
    pad: 'padId',
    kns: 'pumpingStationId',
    field: 'fieldIds',
    company: 'ventureId',
    organization: 'parentId',
};
